import { Button } from "antd";
import useForm from "../../../hooks/common/useForm";
import FormFields from "../FormFields";
import { FormSection } from "../FormSection";
import useSet from "../../../hooks/common/useSet";
import { useParams } from "react-router-dom";
import { actionHooks } from "../../../hooks/handlers/useActionHandler";
import { useToasts } from "../../../hooks/common/useToasts";
import {
  APPROVED,
  CAN_APPROVE_PURCHASE_ORDER,
  CAN_SPECIAL_EDIT,
  DEFERRED,
  DISBURSED,
  REJECTED,
  CAN_APPROVE_PAYROLL,
  CAN_ADD_INVENTORY_CHECKLIST,
  CAN_ADD_PRODUCT_TO_PURCHASE_ORDERS,
} from "../../../utils/constants";
import { itemExists, useGetUserPermissions } from "../../../utils/helpers";

type TGenericActionFormProps = {
  form?: any;
  data?: any;
  setReload?: any;
  source_id?: string;
  updateFormValue?(field_name: string, value: any): void;
};

export const GenericActionForm = ({
  setReload,
  data,
  source_id,
}: TGenericActionFormProps) => {
  const { form, updateFormValue, onChange, updateFormValues } = useForm();
  const { uploadData, submitting, error, success } = useSet();
  let { source_id: source, id } = useParams();
  if (source_id) source = source_id;
  const permissions = useGetUserPermissions();

  function refreshPage() {
    if (setReload) {
      setReload(true);
    } else {
      window.location.reload();
    }
  }

  useToasts({ success, error, callback: refreshPage });

  const {
    fields,
    onSubmit: handleSubmit,
    enableSubmit = false,
    options,
    finalStates,
  } = source && actionHooks[source]
    ? actionHooks[source]({ form, source, data, updateFormValue })
    : [];

  function submitForm(payload: any) {
    if (source) {
      // submit method from form handler
      if (handleSubmit) {
        let upload_data = handleSubmit(payload, id);
        // handle submission
        if (upload_data) return uploadData(upload_data);
      }
    }
  }

  function onSubmit(e: any) {
    e.preventDefault();
    submitForm(form);
  }

  // if no actions are provided
  if (source && !actionHooks[source]) return null;
  // permission controls
  if (
    !itemExists(permissions, [
      CAN_SPECIAL_EDIT,
      CAN_APPROVE_PURCHASE_ORDER,
      CAN_APPROVE_PAYROLL,
      CAN_ADD_INVENTORY_CHECKLIST,
      CAN_ADD_PRODUCT_TO_PURCHASE_ORDERS,
    ])
  )
    return null;
  // not paid status
  if (
    data?.payment_status &&
    data?.payment_status !== "paid" &&
    data?.status !== DISBURSED
  ) {
    return null;
  }
  if (
    (finalStates && finalStates.includes(data?.status)) ||
    (!finalStates && [APPROVED, DEFERRED, REJECTED].includes(data?.status))
  ) {
    return null;
  }

  // if fields are empty, return null
  if (!fields?.length) return null;
  return (
    <form onSubmit={onSubmit}>
      <div>
        <FormSection
          title="Action Form"
          props={{ style: { display: "flex", flexDirection: "column" } }}
        >
          <FormFields
            fields={fields}
            error={error}
            form={form}
            updateFormValue={updateFormValue}
            updateFormValues={updateFormValues}
            onChange={onChange}
            options={options}
          />
          {/* Submit Button */}
          <div>
            <Button
              type="primary"
              htmlType="submit"
              disabled={!enableSubmit}
              loading={submitting}
              style={{ width: 110 }}
            >
              Submit
            </Button>
          </div>
        </FormSection>
      </div>
    </form>
  );
};
